import axios from "./config/axios"

export const getSwaggerDefinition = async () => {
	const { data } = await axios.get("/docs/swagger.json")
	return data
}
